<div class="principal-container">
  <div class="steps">
    <app-stepper action="payment"></app-stepper>
  </div>
  <div class="header-container">
    <p class="title">Elige el método de pago</p>
  </div>

  <div class="methods-container">
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <div class="cards-method">
          <img
            src="../assets/../../../../assets/images/cards.png"
            alt=""
            class="img-cards"
          />
          <p class="text-card">
            Tarjeta de
            <br />
            crédito/débito
          </p>
        </div>
      </div>
      <div class="col-md-4 col-sm-12">
        <div class="paypal-method">
          <img
            src="../assets/../../../../assets/images/paypal.png"
            alt=""
            class="img-paypal"
          />
          <p class="text-paypal">
            PayPal
          </p>
        </div>
      </div>
      <div class="col-md-4 col-sm-12">
        <div class="pse-method">
          <img
            src="../assets/../../../../assets/images/pse.png"
            alt=""
            class="img-pse"
          />
          <p class="text-pse">
            PSE
          </p>
        </div>
      </div>
    </div>
    <p class="select-card">
      Selecciona tu tarjeta
    </p>
    <div class="cards-logos">
      <img
        class="mastercard-img"
        src="../assets/../../../../assets/images/mastercard.png"
        alt=""
      />
      <img
        class="visa-img"
        src="../assets/../../../../assets/images/visa.png"
        alt=""
      />
      <img
        class="american-express-img"
        src="../assets/../../../../assets/images/american-express.png"
        alt=""
      />
    </div>
  </div>
  <div class="auth-container"></div>
</div>
<app-footer></app-footer>
